import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appConfig } from 'src/app/configurations';
import { appRoutes } from 'src/app/routes';
import { coreConfig } from 'src/core/configurations';
import { coreRoutes } from 'src/core/routes';

export const mainConfig: ApplicationConfig = mergeApplicationConfig(
  { providers: [provideRouter([...appRoutes, ...coreRoutes])] },
  coreConfig,
  appConfig,
);
